'use client';

import { useEffect } from 'react';
import { mutate } from 'swr';
import { ThankYou } from 'components/ui/organisms';
import { setIsCTADisabled, useAppDispatch } from 'store';
import { TasticProps } from '../types';
import { ThankYouDataSource } from './types';

export const ThankYouTastic = ({ data }: TasticProps<ThankYouDataSource>) => {
  const dispatch = useAppDispatch();
  const { order, program } = data.order.dataSource;

  // clear the CTA state and getCart cache on mount
  useEffect(() => {
    dispatch(setIsCTADisabled(false));
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    mutate('/action/cart/getCart', undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!order) {
    window.location.replace(process.env.NEXT_PUBLIC_EDX_LEARNER_DASHBOARD_URL!);
    return null;
  }

  return <ThankYou order={order} program={program} />;
};
